import Vue from 'vue'
import Vuex from 'vuex'
import {get,post} from '@/util/http';
import api from '@/util/api'
import home from './modules/home'
import menu from './modules/menu'
import cifi from './modules/cifi'
import news from './modules/news'
import adwrap from './modules/adwrap'
import forum from './modules/forum'
import exhibitor from './modules/exhibitor'
import project from './modules/project'
import material from './modules/material'
import participation from './modules/participation'

Vue.use(Vuex)


const store = new Vuex.Store({
    state: {
        showNoticeBox:true,
        user:{},
    },
    mutations:{
        setUser(state,data){
            state.user=data
        }
    },
    modules: {
        menu,
        home,
        cifi,
        news,
        adwrap,
        forum,
        exhibitor,
        project,
        material,
        participation,
    },
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js